// Seitenwechsel Liste ↔ Objekt ↔ Einheit (README §4.8).
// Nutzt document.startViewTransition, wenn verfügbar; sonst sofort ausführen.

import { flushSync } from 'react-dom';
import { bewegungReduziert } from './motion';

type MitViewTransition = Document & {
  startViewTransition?: (cb: () => void) => { finished: Promise<void> };
};

/** Gemeinsamer view-transition-name für Kachel und Hero eines Objekts. */
export function objektTransitionName(objektId: string): string {
  return `obj-${objektId.replace(/[^a-zA-Z0-9_-]/g, '')}`;
}

export function mitViewTransition(aktualisiere: () => void): void {
  const doc = document as MitViewTransition;
  const geht = typeof doc.startViewTransition === 'function'
    && document.visibilityState === 'visible'
    && !bewegungReduziert();
  if (!geht || !doc.startViewTransition) {
    aktualisiere();
    return;
  }
  // flushSync, damit der neue DOM-Zustand im Callback fertig gerendert ist.
  doc.startViewTransition(() => flushSync(aktualisiere));
}
